import { forwardRef } from "react";
import { Link } from "@tanstack/react-router";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import type { JobSignInSearch } from "@/features/job-post/utils/build-job-signin-search";

interface PublicJobCtaCardProps {
  title?: string | null;
  signinSearch: JobSignInSearch;
}

export const PublicJobCtaCard = forwardRef<
  HTMLDivElement,
  PublicJobCtaCardProps
>(function PublicJobCtaCard({ title, signinSearch }, ref) {
  return (
    <Card
      ref={ref}
      className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm flex flex-col sm:flex-row items-center gap-4 sm:justify-between"
    >
      <div className="text-center sm:text-left">
        <p className="text-base font-semibold text-gray-900">
          {title ? `Interested in "${title}"?` : "Interested in this position?"}
        </p>
        <p className="mt-1 text-sm text-gray-500">
          Sign up to apply and get matched with opportunities like this one.
        </p>
      </div>
      <Button asChild size="lg" className="w-full sm:w-auto shrink-0">
        <Link to="/auth-provider/signin" search={signinSearch}>
          Sign up to apply
        </Link>
      </Button>
    </Card>
  );
});
